// extracted by mini-css-extract-plugin
export default {"enter-phone":"test-shooting-card_enter-phone__+Z9NF","fire-test-message":"test-shooting-card_fire-test-message__vOOaM"};